<template>
  <!-- 头部 -->
  <div class="  s_flex_bian_c">
    <div class='s_flex_ali'>
      <span class='mr15 ' v-if='group_type==1'>
        <a-button type="primary" shape="round" class='m-r-20' v-has:productImgMaterialAdd='()=>{uploadVisible=true}'>
          <PlusOutlined />
          添加图片
        </a-button>
        大小不超过500K,支持gif/png/jpeg/jpg
      </span>
      <span class='mr15 ' v-else>
        <a-button type="primary" shape="round" class='m-r-20' v-has:productVideoMaterialAdd='()=>{uploadVideoVisible=true}'>
          <PlusOutlined />
          添加视频
        </a-button>
        大小不超过20M
      </span>
    </div>
    <a-input-search placeholder="标题" enter-button v-model:value="search.name" @search="onSearch" style="width:300px" />
  </div>
  <!-- 素材内容 -->
  <a-layout  id="components-layout-demo-custom-trigger">
    <a-layout-sider :trigger="null" collapsible style="background: #fff;padding-top:20px">
      <a-menu mode="inline" v-model:selectedKeys="defaultSelected" @click="handleMaterialCate" style="height: 618px;overflow-y: scroll;">
        <a-menu-item key="">
          <span>全部{{group_type==1?"图片":"视频"}}</span>
        </a-menu-item>
        <a-menu-item key="0">
          <span>未分组({{ungrouped}})</span>
        </a-menu-item>
        <a-menu-item v-for="v in CateList" :key='v.id'>
            <div class="s_flex_bian_c">
                   <span class="s_flex_ali"><span  style="display: inline-block;max-width:6em;" class="s_omit">{{v.group_name}}</span>({{v.total}})</span><span >
            <DeleteOutlined v-has:productMaterialGroupDel="()=>DelCate(v.id)" />
            <EditOutlined v-has:productMaterialGroupEdit="()=>{group=v;visible=true;groupAddType ='edit'}" />
          </span>
            </div>
        </a-menu-item>
      </a-menu>
      <a-button class="m-t-10" type="primary" ghost block v-has:productMaterialGroupCreate='()=>{visible=true;groupAddType ="add"}'>
        <PlusOutlined />
        添加分组
      </a-button>
    </a-layout-sider>
    <a-layout >
      <a-layout-header style="background: #fff; padding: 0">
        <a-checkbox v-model:checked="checkAll" @change="onCheckAllChange" class='m-l-25'>
          全选
        </a-checkbox>
        <a-button type="link" class='m-r-20' v-has:productMaterialAllMove='()=>changGroup(checkedList)' v-if='checkedList.length > 0'>
          移动分组
        </a-button>
        <a-button type="link" class='m-r-20' v-has:productMaterialAllDel="productMaterialDel" v-if='checkedList.length > 0'>
          删除
        </a-button>
      </a-layout-header>
      <a-layout-content :style="{  padding: '12px', background: '#fff', minHeight: '280px' }">
        <a-checkbox-group v-model:value="checkedList" @change="onChange" class='width100'>
          <a-spin :spinning="loading">
            <ul class=" librayList" v-if="images.length">
              <li style="width:25%;display:inline-block" v-for="(v,k) in images" :key='k'>
                <div class="content ">
                  <div class="imgContent" style="width:100%;" :style="{backgroundImage:'url('+info.picdomain+'/'+v.file_name+')'}" v-if="group_type==1" >
                  </div>
                  <div class="imgContent" style="width:100%;"  v-else  :style="{backgroundImage:'url('+info.picdomain+'/'+v.video_image_name+')'}">
                  </div>
                  <a-checkbox :value="v.id" name="type" class=' m-t-8 m-b-10 width95 s_omit'>
                    {{v.name}}.{{v.extension}}
                  </a-checkbox>
                </div>
                <div class="material_foot">
                  <div class="button-group">
                    <div v-has:productMaterialUpdateName='()=>changName(v)'>改名</div>
                    <div @click="copy(info.picdomain+v.file_name)">链接</div>
                    <!-- <div @click="copy(info.picdomain+'/'+v.file_name)" v-else>链接</div> -->
                    <div>
                      <a-dropdown>
                        <a class="ant-dropdown-link" @click="e => e.preventDefault()"> 更多
                          <DownOutlined />
                        </a>
                        <template #overlay>
                          <a-menu>
                            <a-menu-item key="0">
                              <div v-has:productMaterialMove='()=>changGroup([v.id])'>分组</div>
                            </a-menu-item>
                            <a-menu-item key="1">
                              <div v-has:productMaterialDel='()=>delMaterial(v.id)'>删除</div>
                            </a-menu-item>
                          </a-menu>
                        </template>
                      </a-dropdown>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <a-empty v-if="!images.length" />
          </a-spin>
        </a-checkbox-group>
        <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  v-if="total"/>
      </a-layout-content>
    </a-layout>
  </a-layout>
  <!-- 添加分组 -->
  <a-modal  :keyboard="false" title="分组管理" v-model:visible="visible" centered :confirm-loading="confirmLoadingType" @ok="handleOk" style="width:700px">
    <a-form ref="groupForm" :model="group" :label-col="{span:4}" :wrapper-col="{span:20}">
      <a-form-item ref="group_name" label="分组名称" name="group_name" :rules="[{ required: true, message: '请输入分组名称' },{ max: 10, message: '分组名称不超过10个字符' }]">
        <a-input v-model:value="group.group_name" />
      </a-form-item>
      <a-form-item ref="id" name="id" hidden>
        <a-input v-model:value="group.id" />
      </a-form-item>
    </a-form>
  </a-modal>
  <!-- 上传图片 -->
  <a-modal  :keyboard="false" title="图片上传" centered v-model:visible="uploadVisible" :confirm-loading="confirmLoading" @ok="handleUpLoad" :width='500'>
    <a-form ref="upLoadForm" :model="upLoad" :label-col="{span:4}" :wrapper-col="{span:14}">
      <a-form-item ref="group_id" label="图片分组" name="group_id">
        <a-select v-model:value="upLoad.group_id" ref="select" placeholder="默认未分组">
          <a-select-option value='0'>
            <span>默认未分组</span>
          </a-select-option>
          <a-select-option v-for="v in CateList" :value='v.id' :key="v.id">
            <span>{{v.group_name}}</span>
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item ref="image" label="图片" name="image" help='支持jpg/png格式' :rules="[{ required: true, message: '请上传图片' }]">
        <a-upload v-model:fileList="upLoad.image" v-model:value="upLoad.file" name="file" accept='image/jpeg,image/png,image/jpg,image/gif' list-type="picture-card" multiple @preview="handlePreview" :beforeUpload='()=>false'>
          <div>
            <plus-outlined />
            <div class="ant-upload-text">上传图片</div>
          </div>
        </a-upload>
      </a-form-item>
    </a-form>
  </a-modal>
  <!-- 上传视频 -->
  <a-modal  :keyboard="false" title="视频上传" centered v-model:visible="uploadVideoVisible" :confirm-loading="confirmLoading" @ok="handleUpLoad" :width='700'>
    <a-form ref="upLoadForm" :model="upLoad" :label-col="{span:4}" :wrapper-col="{span:14}">
      <a-form-item ref="name" label="视频名称" name="name" :rules="[{ required: true, message: '请输入视频名称' },{ max: 10, message: '视频名称不超过10个字符' }]">
        <a-input v-model:value="upLoad.name" />
      </a-form-item>
      <a-form-item ref="group_id" label="视频分组" name="group_id" :rules="[{ required: true, message: '请选择分组' }]">
        <a-select v-model:value="upLoad.group_id" ref="select">
          <a-select-option value='0' v-if="CateList.length==0">
            <span>默认未分组</span>
          </a-select-option>
          <a-select-option v-for="v in CateList" :value='v.id' :key="v.id">
            <span>{{v.group_name}}</span>
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item ref="video_image_name" label="视频封面" name="video_image_name" help='支持上传一张' :rules="[{ required: true, message: '请上传视频封面' }]">
        <a-upload name="video_image_name" @change="videoImgChange" v-model:fileList="upLoad.video_image_name" accept='image/jpeg,image/png,image/jpg,image/gif' list-type="picture-card" @preview="handlePreview" :beforeUpload='()=>false'>
          <div>
            <plus-outlined />
            <div class="ant-upload-text">视频封面</div>
          </div>
        </a-upload>
      </a-form-item>
      <a-form-item ref="video" label="视频" name="video" help='支持MP4格式,大小限制2M内，同时只支持上传一部视频。' :rules="[{ required: true, message: '请上传视频' }]">
        <a-upload name="video" v-model:fileList="upLoad.video" @change="videoChange" @previewFile="previewVideo" accept='video/mp4' list-type="picture-card" :beforeUpload='()=>false'>
          <div>
            <plus-outlined />
            <div class="ant-upload-text">上传视频</div>
          </div>
        </a-upload>
      </a-form-item>
    </a-form>
  </a-modal>
  <!-- 图片预览 -->
  <a-modal  :keyboard="false" :visible="previewVisible" centered :footer="null" @cancel="previewVisible=false">
    <img alt="example" style="width: 100%" :src="previewImage" />
  </a-modal>
  <!-- 视频预览 -->
  <a-modal  :keyboard="false" :visible="previewVideoVisible"  :footer="null" @cancel="previewVideoVisible=false" :width="750" :height="500">
     <video alt="example" style="width:700px;height:400px" :src="videoPreview" autoplay controls />
  </a-modal>
  <!-- 修改图片名称 -->
  <a-modal  :keyboard="false" title="修改名称" centered v-model:visible="materialVisible" :confirm-loading="confirmLoading" @ok="handleUpdateName" style="width:700px">
    <a-form ref='materialForm' :model='material' :label-col="{span:4}" :wrapper-col="{span:20}">
      <a-form-item ref="name" label="素材名称" name="name" :rules="[{ required: true, message: '请输入素材名称' },{ max: 10, message: '素材名称不超过10个字符' }]">
        <a-input v-model:value="material.name" />
      </a-form-item>
      <a-form-item ref="id" label="素材ID" name="id" hidden>
        <a-input v-model:value="material.id" />
      </a-form-item>
    </a-form>
  </a-modal>
  <!-- 移动分组-->
  <a-modal  :keyboard="false" title="选择分组" centered v-model:visible="materialGroupVisible" :confirm-loading="confirmLoading" @ok="handleMaterialGroup" style="width:700px">
    <a-form ref='materialGroupForm' :model='materialGroup' :label-col="{span:4}" :wrapper-col="{span:20}">
      <a-form-item ref="group_id" label="素材分组" name="group_id" :rules="[{ required: true, message: '请选择分组' }]">
        <a-select v-model:value="materialGroup.group_id" ref="select" placeholder="未分组">
          <a-select-option v-for="v in CateList" :value='v.id' :key="v.id">
            <span>{{v.group_name}}</span>
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item ref="id" label="素材ID" name="id" hidden>
        <a-input v-model:value="materialGroup.id" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { message, Modal } from "ant-design-vue";
import * as Icon from "@ant-design/icons-vue";
import { inject, onMounted, reactive, ref, toRef, toRefs, watch } from "vue";
import {
  getResourceGroup,
  createResourceGroup,
  uploadImage,
  getImage,
  deleteResourceGroup,
  updateResourceGroup,
  getVideo,
  uploadVideo,
  deleteAll,
  deleteMaterial,
  updateName,
  updateGroup,
} from "@/api/material";
import store from "@/store";
import { iscode } from "@/utils/app";
export default {
  components: { ...Icon },
  props: {
    groupType: {
      type: Number,
       default(){ 
        return 1;
      },
    },
  },
  setup(props) {
    const state = reactive({
      groupAddType:'add',
      action: "", //上传地址
      headers: {}, //请求头
      checkedList: [], //checkbox 集合
      indeterminate: true,
      checkAll: false,
      plainOptions: [],
      CateList: [], //分组列表
      visible: false, //分组弹框
      images: [], //图片素材
      defaultSelected: ["-1"], //默认选中分组
      fileList: [], //图片列表
      uploadVisible: false, //上传图片弹窗
      uploadVideoVisible: false, //上传视频弹窗
      loading: false, //加载状态
      confirmLoading: false, //表单提交状态
      confirmLoadingType:false,
      previewImage: "",
      previewVisible: false,
      videoPreview: "",
      previewVideoVisible: false,
      total: 0,
      info: store.state.user.info,
      ungrouped:''
    });
    var group_type = ref(props.groupType);
    // 获取分组信息
    const getGroup = async () => {
      let result = await getResourceGroup({ group_type: props.groupType });
      state.CateList = result.data.data;
    };
    // 新建分组
    const groupForm = ref(); //表单
    const group = ref({ group_name: "", group_type: props.groupType });
    const handleOk = () => {
      state.confirmLoadingType = true;
      groupForm.value
        .validate()
        .then(async (e) => {
          let result
          if(state.groupAddType == 'add'){
            result = await createResourceGroup({...e,group_type: props.groupType}).then((res) => res.data).catch((error) => error);
          }else{
            result = await updateResourceGroup({...e,group_type: props.groupType}).then((res) => res.data).catch((error) => error);
          }
          if (iscode(result, true)) {
            groupForm.value.resetFields();
            state.visible = false;
            getGroup();
          }
        })
        .catch((error) => console.log(error));
      state.confirmLoadingType = false;
    };
    // 删除分组
    const DelCate = (id) => {
      Modal.confirm({
        centered: true,
        content: "删除后该分类将无法恢复，您确定要删除该分类吗？",
        onOk: async () => {
          let res = await deleteResourceGroup(id).then((res) => res.data);
          if (iscode(res, true)) {
            getGroup();
            search.value.group_id = "";
            search.value.page = 1;
            initData(search.value);
          }
        },
      });
    };
    // 上传
    const upLoadForm = ref();
    const upLoad = ref({ image: [], name: "", group_id: "" });
    const handleUpLoad = () => {
      upLoadForm.value
        .validate()
        .then(async (e) => {
          state.confirmLoading = true;
          let formData = new FormData();
          for (let k in e) {
            if (k == "video_image_name") {
              formData.append(
                "video_image_name",
                e["video_image_name"][0].originFileObj
              );
            } else if (k === "image") {
              for (let i = 0; i < e["image"].length; i++) {
                formData.append("image[]", e["image"][i].originFileObj);
              }
            } else {
              if (k == "video") {
                formData.append("video", e[k][0].originFileObj);
              } else {
                formData.append(k, e[k]);
              }
            }
          }
          var result;
          if (e.video) {
            result = await uploadVideo(formData)
              .then((res) => res.data)
              .catch((error) => error);
          } else {
            result = await uploadImage(formData)
              .then((res) => res.data)
              .catch((error) => error);
          }
          state.uploadVisible = false;
          state.uploadVideoVisible = false;
          state.confirmLoading = false;
          if (iscode(result, true)) {
            search.value.page = 1;
            search.value.group_id=upLoad.value.group_id
            state.defaultSelected=[upLoad.value.group_id]
            // handleMaterialCate
            getGroup();
            initData(search.value);
            setTimeout(() => {
              upLoadForm.value.resetFields();
              upLoad.value = {};
            }, 100);
          }
        })
        .catch((error) => console.log(error));
    };
    // 图片预览
    const handlePreview = async (file) => {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      state.previewImage = file.url || file.preview;
      state.previewVisible = true;
    };
    const getBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    };
    // 视频预览
    const showVideo = async (file) => {
      state.previewVideoVisible=true
      state.videoPreview=file
    };
    // 上传视频封面变动
    const videoImgChange = (info) => {
      upLoad.value.video_image_name = info.fileList.splice(
        info.fileList.length - 1,
        1
      );
    };
    const videoChange = (info) => {
      upLoad.value.video = info.fileList.splice(info.fileList.length - 1, 1);
    };
    // 搜索
    var search = ref({ limit: 8, group_id: "", name: "", page: 1 });
    const onSearch = () => {
      search.value.page = 1;
      initData(search.value);
    };
    // 全选
    const onCheckAllChange = (e) => {
      Object.assign(state, {
        checkedList: e.target.checked ? state.plainOptions : [],
      });
    };
    const onChange = (checkedList) => {
      state.indeterminate =
        !!checkedList.length && checkedList.length < state.plainOptions.length;
      state.checkAll = checkedList.length === state.plainOptions.length;
    };
    // 获取列表
    const _lodash = inject("_lodash");
    const initData = async (data) => {
      state.loading = true;
         state.ungrouped =0
      var result;
      state.images=[]
      if (props.groupType == 1) {
        result = await getImage(data)
          .then((res) => res.data.data)
          .catch((error) => error);
      } else {
        result = await getVideo(data)
          .then((res) => res.data.data)
          .catch((error) => error);
      }
      state.loading = false;
      state.checkedList = [];
 
      state.images = result ? result.list.data : [];
      state.ungrouped = result.no_total || 0
      // 整理数据用于全选
      state.plainOptions = _lodash.map(state.images, "id");
      state.total = result.list.total;
    };
    // 点击分组
    const handleMaterialCate = (item, key) => {
      // if(!item.key)return
      // state.images = [];
      search.value.group_id = item.key || "";
      search.value.page = 1;
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    onMounted(() => {
      getGroup();
      initData(search.value);
    });
    // 删除素材
    const delMaterial = (id) => {
      Modal.confirm({
        centered: true,
        content: "删除后将无法恢复，您确定要删除吗？",
        onOk: async () => {
          let res = await deleteMaterial({ id }).then((res) => res.data);
          if (iscode(res, true)) {
            search.value.page = 1;
            initData(search.value);
            getGroup();
          }
        },
      });
    };
    // 批量删除
    const productMaterialDel = async () => {
      Modal.confirm({
        centered: true,
        content: "删除后将无法恢复，您确定要删除吗？",
        onOk: async () => {
          let res = await deleteAll({
            id: JSON.stringify(state.checkedList),
          }).then((res) => res.data);
          if (iscode(res, true)) {
            search.value.page = 1;
            initData(search.value);
            state.checkAll = false;
          }
        },
      });
    };
    // 复制
    const copy = (link) => {
      var input = document.createElement("input"); // 直接构建input
      input.value = link; // 设置内容
      document.body.appendChild(input); // 添加临时实例
      input.select(); // 选择实例内容
      document.execCommand("Copy"); // 执行复制
      document.body.removeChild(input); // 删除临时实例
      message.success("复制成功");
    };
    // 修改素材名称
    const material = ref(); //存放修改数据
    const materialForm = ref(); //声明表单
    const materialVisible = ref(false);
    const changName = (data) => {
      materialVisible.value = true;
      material.value = data;
    };
    // 提交修改
    const handleUpdateName = () => {
      materialForm.value.validate().then(async (e) => {
        let result = await updateName(e)
          .then((res) => res.data)
          .catch((error) => error);
        if (iscode(result, true)) {
          materialVisible.value = false;
      getGroup();
          initData(search.value);
        }
      });
    };
    // 修改分组
    const materialGroupForm = ref(); //声明表单
    const materialGroup = ref({ id: "", group_id: "" }); //存放修改数据
    const materialGroupVisible = ref(false);
    const changGroup = (data) => {
      materialGroupVisible.value = true;
      materialGroup.value.id = data.join(",");
    };
    const handleMaterialGroup = () => {
      materialGroupForm.value.validate().then(async (e) => {
        let result = await updateGroup(e)
          .then((res) => res.data)
          .catch((error) => error);
          state.checkAll=false
        if (iscode(result, true)) {
          materialGroupVisible.value = false;
          initData(search.value);
      getGroup();

        }
      });
    };
    return {
      ...toRefs(state),
      group_type,
      onSearch,
      search,
      group,
      handleOk,
      handleMaterialCate,
      groupForm,
      upLoadForm,
      handleUpLoad,
      upLoad,
      handlePreview,
      pageSizeChange,
      pageCurrentChange,
      DelCate,
      delMaterial,
      onChange,
      onCheckAllChange,
      productMaterialDel,
      copy,
      changName,
      handleUpdateName,
      materialForm,
      material,
      materialVisible,
      handleMaterialGroup,
      changGroup,
      materialGroup,
      materialGroupForm,
      materialGroupVisible,
      videoImgChange,
      videoChange,
      showVideo,
    };
  },
};
</script>
<style lang="less" scoped>
.librayList {
  border: 1px solid #eee;
  flex-wrap: wrap;
  height: 515px;
  overflow: hidden;
  min-width: 100%;
  li {
    border-right: 1px solid #eee;
    border-bottom: 1px solid #eee;
    padding-bottom: 12px;
    &:nth-child(4n) {
      border-right: none;
    }
    &:nth-child(n + 5) {
      border-bottom: 0;
    }
    .content {
      box-sizing: border-box;
      padding: 10px;
      padding-bottom: 0;
      .imgContent {
        width: ~`vw(230) `;
        height: 150px;
        overflow: hidden;
        margin: 0 auto;
        background-repeat: no-repeat;
        background-size: cover;
      }
      .videoContent{
        position: relative;
        cursor: pointer;
      }
      .videoContent::before{
        content: '';
        background-image: url('../../../../assets/images/play.png');
        background-size: contain;
        position: absolute;
        left: 50%;
        top:25%;
        transform: translateX(-50%);
        width: 50px;
        z-index: 1;
        height: 50px;
      }
      .videoContent::after{
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,.5);
      }
      img {
        width: 100%;
        display: block;
      }
      video {
        width: 100%;
        height: 100%;
      }
    }
    .material_foot {
      padding: 0 5px;
      cursor: pointer;
      .button-group {
        width: 100%;
        padding: 8px 0;
        background-color: #f5f5f8;
        font-size: 14px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #05486A;
        display: flex;
        div {
          flex: 1;
          text-align: center;
        }
      }
    }
  }
}
</style>